import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return null;
    }

    return window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
  routes: [
    {
      path: '/adatvedelmi-nyilatkozat',
      name: 'PrivacyStatement',
      component: loadView('PrivacyStatement'),
    },
    {
      path: '/jogi-nyilatkozat',
      name: 'LegalNotice',
      component: loadView('LegalNotice'),
    },
    {
      path: '/',
      name: 'Home',
      component: loadView('Home'),
    },
    {
      path: '*',
      name: '404',
      redirect: { name: 'Home' },
    },
  ],
});
